import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import './SettingsPage.css';

export function SettingsPage() {
  const { t } = useLanguage();
  const { user, userProfile, deleteAccount } = useAuth();
  const navigate = useNavigate();
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState('');

  const handleDeleteAccount = async () => {
    if (!window.confirm(t('settings.deleteAccountConfirm'))) {
      return;
    }

    try {
      setDeleting(true);
      setError('');
      await deleteAccount();
      navigate('/');
    } catch (err: any) {
      console.error('Failed to delete account:', err);
      setError(err.message || 'Failed to delete account');
      setDeleting(false);
    }
  };

  return (
    <div className="settingsPage">
      <h1>{t('settings.title')}</h1>

      <section className="settingsSection">
        <h2>{t('settings.accountInfo')}</h2>
        <div className="settingsInfoGrid">
          <div className="settingsInfoRow">
            <span className="settingsInfoLabel">{t('dashboard.email')}</span>
            <span className="settingsInfoValue">{user?.email}</span>
          </div>
          <div className="settingsInfoRow">
            <span className="settingsInfoLabel">{t('auth.signup')}</span>
            <span className="settingsInfoValue">{user?.displayName || userProfile?.displayName}</span>
          </div>
          {userProfile?.createdAt && (
            <div className="settingsInfoRow">
              <span className="settingsInfoLabel">{t('dashboard.memberSince')}</span>
              <span className="settingsInfoValue">
                {new Date(userProfile.createdAt).toLocaleDateString()}
              </span>
            </div>
          )}
          {userProfile?.subscriptionTier && (
            <div className="settingsInfoRow">
              <span className="settingsInfoLabel">{t('dashboard.subscription')}</span>
              <span className="settingsInfoValue">{userProfile.subscriptionTier}</span>
            </div>
          )}
        </div>
      </section>

      <section className="settingsSection settingsDangerZone">
        <h2>{t('settings.dangerZone')}</h2>
        <p className="settingsDangerDesc">{t('settings.deleteAccountDesc')}</p>

        {error && <p className="settingsError">{error}</p>}

        <button
          className="settingsDeleteButton"
          onClick={handleDeleteAccount}
          disabled={deleting}
          data-testid="delete-account-button"
        >
          {deleting ? t('settings.deleting') : t('settings.deleteAccountButton')}
        </button>
      </section>
    </div>
  );
}
